import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
} from "@angular/core";
import { ILinkTyped } from "src/app/shared/interface/link";
import { IUProperty } from "src/app/shared/interface/umbraco-property";

export interface IOnboardingPanelCard {
  header: IUProperty<string>;
  price: IUProperty<string>;
  priceDescription: IUProperty<string>;
  info: IUProperty<string>;
  textColor: IUProperty<string>;
  link: IUProperty<ILinkTyped>;
  linkHexColor: IUProperty<string>;
  bodyColor: IUProperty<string>;
}


@Component({
  selector: "app-onboarding-panel-card",
  templateUrl: "./onboarding-panel-card.component.html",
  styleUrls: ["./onboarding-panel-card.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingPanelCardComponent implements AfterViewInit {
  @Input() data: IOnboardingPanelCard;

  get isCurrencyNumber() {
    return (
      this.data &&
      this.data.price &&
      this.data.price.value &&
      /^-{0,1}\d*\.{0,1}\d+$/.test(this.data.price.value)
    );
  }

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.data);
  }

  private setCustomThemeProperties(d: IOnboardingPanelCard) {

    if (d.bodyColor && d.bodyColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--onboarding-card-body-color",
        d.bodyColor.value
      );
    }

    if (d.textColor && d.textColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--onboarding-card-text-color",
        d.textColor.value
      );
    }

    if (d.linkHexColor && d.linkHexColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--onboarding-card-link-color",
        d.linkHexColor.value
      );
    }
  }
}
